import { render, staticRenderFns } from "./BimEngineeringChangeCategory.vue.html?vue&type=template&id=54bd9f6b&lang=html&external"
import script from "./BimEngineeringChangeCategory.vue.js?vue&type=script&lang=js&external"
export * from "./BimEngineeringChangeCategory.vue.js?vue&type=script&lang=js&external"
import style0 from "./BimEngineeringChangeCategory.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports